module.exports = __webpack_public_path__ + "static/media/stymex-2.a2e04166.jpg";